import { createContext, useContext, useState, useEffect } from "react";

const ConsentimientoAuthContext = createContext(null);
const CLAVE_TOKEN = "consentimiento_token";
const CLAVE_USUARIO = "consentimiento_usuario";

export function ConsentimientoAuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const guardado = localStorage.getItem(CLAVE_USUARIO);
    if (guardado) {
      try { setUsuario(JSON.parse(guardado)); } catch { /* corrupto, se ignora */ }
    }
    setCargando(false);
  }, []);

  const iniciarSesion = (token, datosUsuario) => {
    localStorage.setItem(CLAVE_TOKEN, token);
    localStorage.setItem(CLAVE_USUARIO, JSON.stringify(datosUsuario));
    setUsuario(datosUsuario);
  };

  const cerrarSesion = () => {
    localStorage.removeItem(CLAVE_TOKEN);
    localStorage.removeItem(CLAVE_USUARIO);
    setUsuario(null);
  };

  return (
    <ConsentimientoAuthContext.Provider value={{ usuario, cargando, iniciarSesion, cerrarSesion }}>
      {children}
    </ConsentimientoAuthContext.Provider>
  );
}

export function useConsentimientoAuth() {
  return useContext(ConsentimientoAuthContext);
}
